"use client";

import { SubscriptionStatus } from "@prisma/client";
import { BILLING_METERS } from "@/app/(components)/specifics/billing/Billing/Billing.logic";
import { useAuthUser } from "@/app/(components)/specifics/wrappers/AuthProvider/AuthProvider";
import { useCanRunPaidActions } from "@/app/(components)/specifics/wrappers/BrandProvider/BrandProvider";
import { useFetchSubscription } from "@/app/hooks/fetchs/credits/useFetchSubscription";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { DashboardCounters as Counters } from "@/app/types/dashboard/DashboardCounters";
import styles from "./Dashboard.module.css";
import DashboardStat from "./DashboardStat";

type Props = {
  counters: Counters;
};

export default function DashboardCounters(props: Props) {
  const T = useT();
  const { counters } = props;

  const user = useAuthUser();
  const canRunPaidActions = useCanRunPaidActions();
  const { data: overview } = useFetchSubscription({ enabled: !!user && canRunPaidActions });

  const status = overview?.subscription?.status;
  const hasPlan = status === SubscriptionStatus.TRIALING || status === SubscriptionStatus.ACTIVE;
  const plan = overview?.plan;

  return (
    <div className={styles.counters}>
      <DashboardStat
        label={T(TKey.DASHBOARD_COUNTER_ANALYSED_CALLS) as string}
        value={counters.analysedCalls}
        total={counters.totalCalls}
      />

      {canRunPaidActions &&
        user &&
        plan &&
        BILLING_METERS.map((meter) => {
          const used = meter.used(user, plan);

          return (
            <DashboardStat
              key={meter.labelKey}
              label={T(meter.labelKey) as string}
              value={used}
              total={used + meter.left(user, hasPlan)}
            />
          );
        })}
    </div>
  );
}
